<template>
    <div>
        <h1>Frontend</h1>
        <p>So you want to code frontend, huh? Nice!</p>
        <p>You can either use the existing reference API (or <router-link to="/backend">build your own</router-link>) with the following <router-link to="/api">API specification</router-link>.</p>
        <p>If you're not making your own API, then use the following base URL for the API: <i>https://serverless-api.3rik.se/kitchen</i>. That is, the GET /ping method would be <a href="https://serverless-api.3rik.se/kitchen/ping" target="_blank">https://serverless-api.3rik.se/kitchen/ping</a>.</p>

        <FrontendMission></FrontendMission>

        <h3>Choose your stack</h3>
        <p>Difficult choice? Then do them all ;)</p>
        <LinkBox>
            <li><router-link to="/frontend-vue">Goto: Vue</router-link></li>
            <li><router-link to="/frontend-react">Goto: React</router-link></li>
            <li><router-link to="/frontend-angular">Goto: Angular</router-link></li>
        </LinkBox>
    </div>
</template>



<script>
import LinkBox from '@/components/LinkBox.vue'
import FrontendMission from '@/components/FrontendMission.vue'

export default {
    name: 'frontend',
    components: {
        LinkBox,
        FrontendMission
    }
}
/*     <CodeBox>
            <pre>@GetMapping("/ping")
public String ping() {
        return "pong";
}</pre>
        </CodeBox>*/
</script>

<style scoped>

</style>
